// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.auth-wrapper {
  width: 100%;
  height: 100vh;
  padding: 26px 20px 17px 20px;
}

.gc-auth-leftPanel {
  height: 100%;
  background: #fff url('mesh-gradient-bg.4dcf46c1580a723e.png') no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.gc-idnty-container {
  padding: 0 80px;
  margin-top: 0;
  width: 100%;
}
.gc-idnty-container p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
}

.password-check {
  height: 4px;
  width: 100px;
  background-color: #ccc;
}

.password-strength-container {
  display: flex;
  justify-content: flex-end;
}

.weak-password {
  background-color: #FF6B6B; /* Red color */
}

.medium-password {
  background-color: #FEBD2E; /* Yellow color */
}

.strong-password {
  background-color: #66DE93; /* Green color */
}

/* Weak Password Text Style */
.weak-password-text {
  color: #FF6B6B; /* Red color */
  margin: -15px 0 0 0;
}

/* Medium Password Text Style */
.medium-password-text {
  color: #FEBD2E;
  margin: -12px; /* Yellow color */
}

/* Strong Password Text Style */
.strong-password-text {
  color: #66DE93; /* Green color */
  margin: -15px 0 0 0;
}

.gc-auth-slider {
  padding: 0 56px;
  margin-top: 60px;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}

.gc-exp-title {
  width: 196px;
  height: 56px;
  padding: 16px 13px 16px 16px;
  border-radius: 16px;
  background: rgba(45, 51, 69, 0.1019607843);
  margin-left: 50px;
  margin-bottom: 50px;
  margin-top: 100px;
}

.gc-exp-note {
  border-radius: 24px;
  background: rgba(45, 51, 69, 0.1019607843);
  padding: 35px;
  font-size: 21px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #0A6ED9;
}

.forcereset-textbox {
  width: 670px;
  background: #fff;
  max-width: 100%;
  padding: 45px;
  border-radius: 10px;
  margin: auto;
}
.forcereset-textbox p {
  color: #1E38A9;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  margin-top: 55px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/login/forgot-password/force-password-change/force-password-change.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,WAAA;EACA,aAAA;EACA,4BAAA;AAGF;;AADA;EACI,YAAA;EACA,qFAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAIJ;;AAFA;EACE,eAAA;EACA,aAAA;EACA,WAAA;AAKF;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAMJ;;AAFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAKF;;AAHA;EACE,aAAA;EACA,yBAAA;AAMF;;AAJA;EACE,yBAAA,EAAA,cAAA;AAOF;;AAJA;EACE,yBAAA,EAAA,iBAAA;AAOF;;AAJA;EACE,yBAAA,EAAA,gBAAA;AAOF;;AAHA,6BAAA;AACA;EACE,cAAA,EAAA,cAAA;EACA,mBAAA;AAMF;;AAHA,+BAAA;AACA;EACE,cAAA;EACA,aAAA,EAAA,iBAAA;AAMF;;AAHA,+BAAA;AACA;EACE,cAAA,EAAA,gBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,eAAA;EACA,gBAAA;AAOF;;AALA;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAQF;AAPE;EALF;IAMI,iBAAA;EAUF;AACF;;AARA;EACE,YAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAWF;;AATA;EACE,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAYF;;AAVA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAaF;AATE;EACE,cDrFU;ECsFV,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAWJ","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../../../assets/styles/colors.scss\";\n.auth-wrapper {\n  width: 100%;\n  height: 100vh;\n  padding: 26px 20px 17px 20px;\n}\n.gc-auth-leftPanel {\n    height: 100%;\n    background: #fff url(../../../../assets/images/mesh-gradient-bg.png) no-repeat center center;\n    background-size: cover;\n    border-radius: 16px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n.gc-idnty-container{\n  padding:0 80px;\n  margin-top: 0;\n  width: 100%;\n  p{\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    // background-color: #ccc;\n  }\n}\n.password-check{\n  height: 4px;\n  width: 100px;\n  background-color: #ccc;\n}\n.password-strength-container {\n  display: flex;\n  justify-content: flex-end;\n}\n.weak-password {\n  background-color: #FF6B6B; /* Red color */\n}\n\n.medium-password {\n  background-color: #FEBD2E; /* Yellow color */\n}\n\n.strong-password {\n  background-color: #66DE93; /* Green color */\n}\n\n\n/* Weak Password Text Style */\n.weak-password-text {\n  color: #FF6B6B; /* Red color */\n  margin: -15px 0 0 0;\n}\n\n/* Medium Password Text Style */\n.medium-password-text {\n  color: #FEBD2E;\n  margin: -12px; /* Yellow color */\n}\n\n/* Strong Password Text Style */\n.strong-password-text {\n  color: #66DE93; /* Green color */\n  margin: -15px 0 0 0;\n}\n.gc-auth-slider{\n  padding: 0 56px;\n  margin-top: 60px;\n}\n.password-req{\n  font-size: 12px;\n  margin-top: 8px;\n  display: inline-block;\n  line-height: 28px;\n  @media (max-width:1640px) {\n    line-height: 16px;\n  }\n}\n.gc-exp-title{\n  width: 196px;\n  height: 56px;\n  padding: 16px 13px 16px 16px;\n  border-radius: 16px;\n  background: #2D33451A;\n  margin-left: 50px;\n  margin-bottom:50px;\n  margin-top:100px;\n}\n.gc-exp-note{\n  border-radius: 24px;\n  background: #2D33451A;\n  padding:35px;\n  font-size: 21px;\n  font-weight: 500;\n  line-height: 32px;\n  letter-spacing: 0.01em;\n  text-align: left;\n  color: #0A6ED9;\n}\n.forcereset-textbox {\n  width: 670px;\n  background: #fff;\n  max-width: 100%;\n  padding: 45px;\n  border-radius: 10px;\n  margin: auto;\n  .logo{\n    // margin-bottom: 65px;\n  }\n  p{\n    color:$headingText;\n    text-align: center; \n    font-size: 22px;\n    font-weight: 700;\n    line-height: 26px;\n    margin-top: 55px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
